export default __webpack_public_path__ + "static/media/ic-sowing-1.2d4574ec.svg";